<div class="auth-page">
	<div class="form-block">
		<app-set-password></app-set-password>
	</div>
</div>
